import { COLORS } from 'consts/colors'
import styled from 'styled-components'
import { boxShadowStyles } from 'styles/mixins'

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: transparent;
`

export const MenuPanel = styled.div`
  position: fixed;
  z-index: 10001;
  min-width: 200px;
  padding: 8px;
  background: #fff;
  border-radius: 4px;
  ${boxShadowStyles('shadow2')}
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const MenuItem = styled.button`
  display: flex;
  gap: 8px;
  width: 100%;
  border: none;
  background: none;
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS.secondarySemiDark};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  padding: 10px 8px;
  border-radius: 4px;

  &:hover {
    background: ${COLORS.primaryLight};
  }
`

/** Short horizontal rule, centered in the menu panel */
export const MenuDivider = styled.div`
  align-self: center;
  width: 100%;
  height: 1px;
  flex-shrink: 0;
  background: ${COLORS.borderColor};
`
